module.exports = require('./toPairsIn');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/entriesIn.js
// module id = 1986
// module chunks = 3